import React from 'react';

/**
 * PageLoader — single source of truth for in-app loading screens.
 *
 * Renders a thin sage ring spinner + a label, vertically and
 * horizontally centered in its parent container. Use `fullScreen`
 * to take over the whole viewport (default), or pass `fullScreen=false`
 * to fit inside an existing content panel.
 *
 * iter123 — Extracted from TasksPage so every other page (Chat,
 * Email, Calls, etc.) can render the same loading visual at the
 * same screen position.
 */
const PageLoader = ({ label = 'Loading...', fullScreen = true, gradient = true, testId }) => {
  const wrapperClass = fullScreen
    ? `min-h-screen ${gradient ? 'bg-gradient-to-b from-[#d4e4cf] via-[#e8ede6] to-[#c9d4c3] dark:from-[#1a1a1a] dark:via-[#0d0d0d] dark:to-[#000000]' : ''} flex items-center justify-center`
    : 'flex-1 min-h-[55vh] flex items-center justify-center';
  return (
    <div className={wrapperClass} data-testid={testId || 'page-loader'}>
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
        <span className="text-muted-foreground text-sm">{label}</span>
      </div>
    </div>
  );
};

export default PageLoader;
